import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestRecord({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'telatransmitecentral', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteRecord({ payload }) {
  try {
    const { posto_cod_posto, params } = payload;

    yield call(api.delete, `telatransmitecentral/${posto_cod_posto}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* storeRecord({ payload }) {
  try {
    const { telatransmitecentral, params } = payload;

    yield call(api.post, 'telatransmitecentral', telatransmitecentral);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/telatransmitecentral');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* findRecord({ payload }) {
  try {
    const { posto_cod_posto } = payload;

    const { data } = yield call(
      api.get,
      `telatransmitecentral/${posto_cod_posto}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* updateRecord({ payload }) {
  try {
    const { telatransmitecentral, params } = payload;

    yield call(api.put, 'telatransmitecentral', telatransmitecentral);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/telatransmitecentral');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    let { params } = payload;

    params = {
      ...params,
      pagesize: 25,
    };

    const response = yield call(
      api.get,
      'telatransmitecentral/retornatransmitecentral',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@telatransmitecentral/IN_REQUEST', requestRecord),
  takeLatest('@telatransmitecentral/DELETE', deleteRecord),
  takeLatest('@telatransmitecentral/SUCCESS_REMOVE', requestRecord),
  takeLatest('@telatransmitecentral/STORE', storeRecord),
  takeLatest('@telatransmitecentral/FIND', findRecord),
  takeLatest('@telatransmitecentral/UPDATE', updateRecord),
  takeLatest('@telatransmitecentral/RECORD_FILTERING', applyedFilters),
]);
